<div class="container mt-4">
  <ngb-alert
    *ngIf="alert"
    [type]="alert.type"
    (closed)="closeAlert()"
    class="sticky-top"
    style="top: 10px"
    >{{ alert.message }}</ngb-alert
  >

  <div class="row mb-3">
    <div class="col-12">
      <h1 class="text-center">Title</h1>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12 text-center mt-5 mb-3">
      <h5>To change your title, please fill in the field below:</h5>
    </div>
  </div>

  <div class="row mb-5">
    <div class="col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4 mb-3">
      <form
        #updateTitleForm="ngForm"
        (ngSubmit)="save(updateTitleForm)"
        novalidate
      >
        <div *ngIf="existingTitle" class="mb-3">
          <label class="form-label" for="titleCurrent"> Current title </label>
          <input
            #titleCurrent="ngModel"
            class="form-control"
            name="titleCurrent"
            [ngModel]="existingTitle"
            placeholder="Current title"
            readonly
            type="text"
          />
        </div>

        <hr class="my-4" />

        <div>
            <label class="form-label" for="title">
              New title
            </label>
            <select
              #title="ngModel"
              class="form-control form-select"
              [class.is-invalid]="title.touched && title.invalid"
              id="title"
              name="title"
              [required]="true"
              [(ngModel)]="newTitle">
              <option [ngValue]="null" disabled>Please choose an option</option>
              <option *ngFor="let titleEntry of UserTitles" [ngValue]="titleEntry">
                {{ titleEntry }}
              </option>
            </select>
          </div>

        <button
          class="btn btn-success text-white btn-lg w-100 mt-5"
          [disabled]="!updateTitleForm.valid || loading"
          type="submit"
        >
          <fa-icon
            *ngIf="loading"
            [icon]="['fas', 'spinner']"
            [animation]="'spin'"
            class="me-3"
          ></fa-icon>
          {{ loading ? "Saving" : "Save" }}
        </button>
      </form>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12 d-flex justify-content-start mb-3">
      <a *ngIf="!redirectParams" [routerLink]="['/account']">
        <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back to my account
      </a>
      <a
        *ngIf="redirectParams"
        [routerLink]="redirectParams.l"
        [queryParams]="redirectParams.q"
        [fragment]="redirectParams.f"
      >
        <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back
      </a>
    </div>
  </div>
</div>
